import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { interval, Subscription, Observable, forkJoin, Subject, from } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { PurchasingService } from '../../services/purchasing.service';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { Location } from '@angular/common'
import { NoRgaItemsModalComponent } from './no-rga-items-modal/no-rga-items-modal.component';
import { GlPreviewModalComponent, GlPreviewModalData } from '../../shared/gl-preview-modal/gl-preview-modal.component';


@Component({
	selector: 'app-vendor-credit',
	templateUrl: './vendor-credit.component.html',
	styleUrls: ['./vendor-credit.component.scss']
})
export class VendorCreditComponent implements OnInit, OnDestroy {

	invoiceForm: UntypedFormGroup;
	separatorKeysCodes: number[] = [ENTER, COMMA];
	vendor_data: any = [];
	open_grns: any = [];
	all_open_grns: any = [];
	selected_grns: any = [];
	selected_grnbatches: any = [];
	invoice_grns: any = [];
	invoiceTotal = 0.00;
	fetTotal = 0.00;
	taxTotal = 0.00;
	totalTotal = 0.00;
	glcharges: any = [];
	glaccounts: any = [];
	taxes: any = [];
	today = new Date();
	overide_tax = false;
	grn_batches: any = [];
	all_grn_batches: any = [];
	discount: any = 0.00;
	user: any = [];
	errors: any = [];
	color: any = '';
	allglaccounts: any = [];
	company: any = false;
	config: any = [];
	referenceCheck$ = new Subject<string>();
	referenceCheckSubscription: Subscription | null = null;
	@ViewChild('grnInput') grnInput: ElementRef < HTMLInputElement > ;
	attachmentFiles: File[] = [];
	@Output() newvendordata = new EventEmitter<boolean>();

	constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder, private vendorService: VendorService, public router: Router, private location: Location, private globalsService: GlobalsService, public purchasingService: PurchasingService, private globalSearchService: GlobalSearchService, private cdr: ChangeDetectorRef, private dialog: MatDialog) {
		this.color = this.globalSearchService.getColor()
		this.globalSearchService.user.subscribe((user: any) => {
			this.user = user
		});

		this.globalSearchService.company.subscribe((company: any) => {
			this.company = company
		});

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});
	}

	ngOnInit(): void {

		this.route.params.subscribe(params => {
			const supplierid = params['id'];

			this.vendorService.getVendor(supplierid).subscribe((results: any) => {
				this.vendor_data = results;

				this.purchasingService.getRmaGrnDetails(this.vendor_data.supplierid).subscribe((r: any) => {
					this.open_grns = r;
					this.all_open_grns = r;
				})

				this.purchasingService.getRmaOpenGrnBatches(this.vendor_data.supplierid).subscribe((r: any) => {
					this.grn_batches = r;
					this.all_grn_batches = r;
				})

				const due = new Date(this.vendor_data.duedate)

				this.invoiceForm = this.fb.group({
					reference: ['', [Validators.required]],
					invoiceDate: [this.today, [Validators.required]],
					discountAmount: [0.00, [Validators.pattern('[0-9.]*')]],
					discountDate: [due, [Validators.required]],
					dueDate: [due, [Validators.required]],
					rate: [this.roundExchangeRate(this.vendor_data.exrate) ?? this.vendor_data.exrate, [Validators.pattern('[0-9.]*')]],
					grns: [''],
					glsearch: ['']
				});

				if (this.referenceCheckSubscription) {
					this.referenceCheckSubscription.unsubscribe();
				}
				this.referenceCheckSubscription = this.referenceCheck$.pipe(
					debounceTime(400),
					switchMap(ref => this.vendorService.checkCreditReference(this.vendor_data.supplierid, ref))
				).subscribe((res: any) => {
					if (res && res.used) {
						this.invoiceForm.get('reference')?.setErrors({ referenceUsed: true });
						this.globalSearchService.showNotification('Credit reference already used for this vendor.', 'danger', 'bottom', 'right');
					} else {
						const refControl = this.invoiceForm.get('reference');
						const errs = refControl?.errors;
						if (errs?.referenceUsed) {
							const next = { ...errs };
							delete next.referenceUsed;
							refControl.setErrors(Object.keys(next).length ? next : null);
						}
					}
				});

				this.invoiceForm.get('grns').valueChanges.subscribe(newValue => {
				
					if(newValue != '' && newValue != null) {
						this.grn_batches = this.globalSearchService.filterItem(this.all_grn_batches, newValue, 'grnbatch,grnno,orderno,itemcode,sales_orderno')
						this.open_grns = this.globalSearchService.filterItem(this.all_open_grns, newValue, 'grnbatch,grnno,orderno,itemcode,sales_orderno')
					} else {
						this.grn_batches = this.all_grn_batches
						this.open_grns = this.all_open_grns
					}
					this.cdr.detectChanges();
				}); 

				this.invoiceForm.markAllAsTouched();

			});
		});
	}

	back(): void {
		this.location.back()
	}

	onAttachmentSelect(event: { addedFiles: File[] }) {
		this.attachmentFiles.push(...event.addedFiles);
	}

	onAttachmentRemove(file: File) {
		this.attachmentFiles = this.attachmentFiles.filter(f => f !== file);
	}

	private readFileAsDataUrl(file: File): Promise<string | ArrayBuffer> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = e => resolve((e.target as FileReader).result);
			reader.onerror = () => reject(reader.error);
			reader.readAsDataURL(file);
		});
	}

	onReferenceBlur() {
		const ref = this.invoiceForm?.get('reference')?.value?.trim();
		if (!ref || !this.vendor_data?.supplierid) {
			return;
		}
		const refControl = this.invoiceForm.get('reference');
		const errs = refControl?.errors;
		if (errs?.referenceUsed) {
			const next = { ...errs };
			delete next.referenceUsed;
			refControl.setErrors(Object.keys(next).length ? next : null);
		}
		this.referenceCheck$.next(ref);
	}

	/*add(event: MatChipInputEvent): void {
		const value = (event.value || '').trim();

		// Add our fruit
		if (value) {
			this.selected_grns.push(value);
		}

		// Clear the input value
		//event.chipInput!.clear();
		this.grnInput.nativeElement.value = '';
		this.invoiceForm.controls['grns'].setValue(null);
		this.getTotal();
	}*/
	add(event: MatChipInputEvent): void {
		// Prevent manual entry - GRNs should only be added via autocomplete selection
		// This prevents adding undefined/invalid entries when Enter is pressed
		event.chipInput!.clear();
		this.grnInput.nativeElement.value = '';
		this.invoiceForm.controls['grns'].setValue(null);
		this.getTotal();
	}

	removeLine(grn: any): void {
		const index = this.selected_grns.indexOf(grn);

		if (index >= 0) {
			this.selected_grns.splice(index, 1);
		}
		this.getTotal();
	}

	remove(grn: any): void {
		// Find and remove the batch from selected_grnbatches
		const batchIndex = this.selected_grnbatches.indexOf(grn);

		if (batchIndex >= 0) {
			// Add the batch back to the available list
		//	this.grn_batches.push(this.selected_grnbatches[batchIndex]);
			// Remove the batch from selected batches
			this.selected_grnbatches.splice(batchIndex, 1);
		}

		// Remove all GRN items that belong to this specific batch
		// Match by both grnbatch and orderno to ensure accuracy (same logic as selected method)
		const batchGrnbatch = parseFloat(grn.grnbatch) || 0;
		const batchOrderno = parseFloat(grn.orderno) || 0;

		const selected = this.selected_grns.filter((line: any) => {
			const lineGrnbatch = parseFloat(line.grnbatch) || 0;
			const lineOrderno = parseFloat(line.orderno) || 0;
			// Keep items that don't match both grnbatch AND orderno
			return !(lineGrnbatch == batchGrnbatch && lineOrderno == batchOrderno);
		});

		this.selected_grns = selected;
		
		this.getTotal();
	}


	selected(event: MatAutocompleteSelectedEvent): void {

		const index = this.grn_batches.indexOf(event.option.value);
		this.selected_grnbatches.push(event.option.value)

		const selectedBatch = event.option.value;
		const batchGrnbatch = selectedBatch.grnbatch;
		const batchOrderno = selectedBatch.orderno;

		this.grn_batches.splice(index, 1);

		// Filter and add all GRN items that belong to this specific batch
		// Match by both grnbatch and orderno to ensure accuracy
		// Also check if the GRN item is already selected to prevent duplicates
		let itemsAdded = false;
		this.open_grns.forEach((grn: any) => {
			if (parseFloat(grn.grnbatch) == parseFloat(batchGrnbatch) &&
			    parseFloat(grn.orderno) == parseFloat(batchOrderno)) {
				// Check if this GRN item is already in selected_grns to prevent duplicates
				const alreadySelected = this.selected_grns.some((selectedGrn: any) =>
					parseFloat(selectedGrn.grnno) == parseFloat(grn.grnno)
				);
				if (!alreadySelected) {
					// Ensure toinvoice field is set (should come from server, but set default if missing)
					if (grn.toinvoice === undefined || grn.toinvoice === null) {
						grn.toinvoice = (parseFloat(grn.qtyrecd) || 0) - (parseFloat(grn.quantityinv) || 0);
					}
					// Ensure toinvoice is a number, not a string
					grn.toinvoice = parseFloat(grn.toinvoice) || 0;
					this.snapshotPoUnitPrice(grn);
					this.selected_grns.push(grn);
					itemsAdded = true;
				}
			}
		});

		// If no items were found in open_grns, try searching in all_open_grns
		if (!itemsAdded && this.all_open_grns && this.all_open_grns.length > 0) {
			this.all_open_grns.forEach((grn: any) => {
				if (parseFloat(grn.grnbatch) == parseFloat(batchGrnbatch) &&
				    parseFloat(grn.orderno) == parseFloat(batchOrderno)) {
					const alreadySelected = this.selected_grns.some((selectedGrn: any) =>
						parseFloat(selectedGrn.grnno) == parseFloat(grn.grnno)
					);
					if (!alreadySelected) {
						// Ensure toinvoice field is set
						if (grn.toinvoice === undefined || grn.toinvoice === null) {
							grn.toinvoice = (parseFloat(grn.qtyrecd) || 0) - (parseFloat(grn.quantityinv) || 0);
						}
						grn.toinvoice = parseFloat(grn.toinvoice) || 0;
						this.snapshotPoUnitPrice(grn);
						this.selected_grns.push(grn);
					}
				}
			});
		}

		this.grnInput.nativeElement.value = '';
		this.invoiceForm.controls['grns'].setValue(null);
		this.getTotal();
	}

	removeGl(gl: string): void {
		const index = this.glcharges.indexOf(gl);

		if (index >= 0) {
			this.glcharges.splice(index, 1);
		}
		this.getTotal();
	}

	setTaxValue(event: any, tax: any) {
		this.overide_tax = true;
		const index = this.vendor_data.taxes.indexOf(tax);
		this.vendor_data.taxes[index].taxamount = event.target.value;
		this.getTotal();
	}

	/** PO line unit price when line is selected; credit price edits `unitprice` separately for posting. */
	private snapshotPoUnitPrice(grn: any): void {
		const p = parseFloat(grn.unitprice);
		grn.poUnitPrice = Number.isFinite(p) ? p : 0;
	}

	invoicePriceDiffersFromPo(grn: any): boolean {
		const po = parseFloat(grn.poUnitPrice);
		const inv = parseFloat(grn.unitprice);
		if (!Number.isFinite(po) || !Number.isFinite(inv)) {
			return false;
		}
		return Math.abs(po - inv) > 0.000001;
	}

	invoicePricePoDiffTooltip(grn: any): string {
		if (!this.invoicePriceDiffersFromPo(grn)) {
			return '';
		}
		const po = Number(grn.poUnitPrice);
		return 'Credit price differs from PO line price (' + (Number.isFinite(po) ? po.toFixed(2) : '?') + ')';
	}

	/** Pill styling aligned with order item lookup QOH pills (beauty-wqoh compact-pill). */
	vendorRecvdOrdPillClass(grn: any): string {
		const recd = parseFloat(grn.qtyrecd) || 0;
		const ord = parseFloat(grn.quantityord) || 0;
		if (recd !== ord) {
			return 'vendor-qty-pill vendor-qty-pill--red';
		}
		return 'vendor-qty-pill vendor-qty-pill--green';
	}

	vendorInvcdRecdPillClass(grn: any): string {
		const inv = parseFloat(grn.quantityinv) || 0;
		const recd = parseFloat(grn.qtyrecd) || 0;
		if (inv > recd) {
			return 'vendor-qty-pill vendor-qty-pill--red';
		}
		if (recd > 0 && inv < recd) {
			return 'vendor-qty-pill vendor-qty-pill--yellow';
		}
		return 'vendor-qty-pill vendor-qty-pill--green';
	}

	/** KM (`env.client`): allow credit qty above uninvoiced received so PQV mirrors over-billed invoices. */
	private allowVendorQtyOverReceived(): boolean {
		return this.config && this.config.env && this.config.env.client === 'km';
	}

	setQty(event: any, grn: any) {
		const index = this.selected_grns.indexOf(grn);
		const row = this.selected_grns[index];
		if (!this.allowVendorQtyOverReceived()) {
			const qtyrecd = parseFloat(row.qtyrecd) || 0;
			const quantityinv = parseFloat(row.quantityinv) || 0;
			const remaining = Math.max(0, qtyrecd - quantityinv);
			const maxQty = remaining > 0 ? remaining : qtyrecd;
			if (parseFloat(event.target.value) > maxQty) {
				event.target.value = maxQty;
			}
		}

		this.selected_grns[index].toinvoice = event.target.value;
		this.getTotal();
	}

	setDiscount(event: any) {
		this.discount = parseFloat(event.target.value);
		this.getTotal();
	}

	setPrice(event: any, grn: any) {
		const index = this.selected_grns.indexOf(grn);
		this.selected_grns[index].unitprice = event.target.value;
		this.getTotal();
	}

	setGlPrice(event: any, gl: any) {
		const index = this.glcharges.indexOf(gl);
		this.glcharges[index].value = event.target.value;
		this.getTotal();
	}

	getSubTotal() {
		let itemtotal = 0
		itemtotal = this.selected_grns.reduce(function(accumulator, items) {
			return parseFloat(accumulator) + parseFloat(items.unitprice) * parseFloat(items.toinvoice);
		}, 0);

		let gltotal = 0
		gltotal = this.glcharges.reduce(function(accumulator, items) {
			return parseFloat(accumulator) + parseFloat(items.value);
		}, 0);

		// Calculate FET separately (not included in subtotal for tax purposes)
		// Only calculate FET if package is 'tires'
		let fetTotal = 0
		if (this.config && this.config.env && this.config.env.package == 'tires') {
			fetTotal = this.selected_grns.reduce(function(accumulator, items) {
				const fetcharge = parseFloat(items.fetcharge) || 0;
				return parseFloat(accumulator) + fetcharge * parseFloat(items.toinvoice);
			}, 0);
		}

		this.invoiceTotal = itemtotal + gltotal;
		this.fetTotal = fetTotal;
		return itemtotal + gltotal; // Return subtotal without FET

	}

	private roundExchangeRate(value: number | string | null | undefined): number | null {
		const n = value != null ? Number(value) : NaN;
		return !isNaN(n) ? parseFloat(n.toFixed(4)) : null;
	}

	onRateInput(event: Event): void {
		const input = (event.target as HTMLInputElement).value;
		const numericValue = parseFloat(input) / 100;
		const rounded = this.roundExchangeRate(numericValue);
		if (rounded != null) { this.invoiceForm.get('rate')?.setValue(rounded); }
	}
	
	getTaxTotal(subtotal: any) {

		if (!this.overide_tax) {
			this.vendor_data.taxes.forEach((tax, index) => {
				const value = parseFloat(tax.taxrate) * parseFloat(subtotal)
				this.vendor_data.taxes[index].taxamount = value;
			});
		}

		let taxtotal = 0
		taxtotal = this.vendor_data.taxes.reduce(function(accumulator, tax) {
			return (parseFloat(accumulator) + parseFloat(tax.taxamount));
		}, 0);

		this.taxTotal = taxtotal
		return taxtotal;
	}

	getTotal() {

		const subtotal = this.getSubTotal();
		const taxtotal = this.getTaxTotal(subtotal);
		// FET is added after taxes (can't tax tax)
		this.totalTotal = subtotal + taxtotal + this.fetTotal - this.discount;
	}


	addGl(event: any) {
		const selection = event.option.value
		const newGlCharge = {
			account: selection.accountcode,
			name: selection.accountname,
			value: 0.00,
			quantity: 1,
			group: selection.group,
			description: '',
		};

		this.glcharges.push(newGlCharge);
	}
	onEnterKeyDown(event: KeyboardEvent): void {
		event.preventDefault();
		if (this.grnInput && this.grnInput.nativeElement) {
			setTimeout(() => {
				this.grnInput.nativeElement.focus();
			}, 0);
		}
	}

	openGlPreview(): void {
		if (!this.selected_grns.length && !this.glcharges.length) {
			this.globalSearchService.showNotification('Add GRN lines or GL charges to preview posting.', 'info', 'bottom', 'right');
			return;
		}
		this.getTotal();
		const payload = {
			vendor: this.vendor_data,
			header: this.invoiceForm.value,
			grns: this.selected_grns,
			glcharges: this.glcharges,
			subtotal: this.invoiceTotal,
			taxes: this.taxTotal,
			total: this.totalTotal,
			user: this.user,
		};
		this.dialog.open(GlPreviewModalComponent, {
			width: '1160px',
			maxWidth: '98vw',
			panelClass: 'gl-preview-dialog-panel',
			data: {
				title: 'Vendor credit — GL preview',
				getPreview: (_excludeTypenos?: number[], _sampleScope?: 'all' | 'current_year') =>
					this.vendorService.previewCreditGl(payload),
			} as GlPreviewModalData,
		});
	}

	onSubmit() {
		this.getTotal();
		this.errors = false;
		for (const el in this.invoiceForm.controls) {
			if (this.invoiceForm.controls[el].errors) {
				this.errors = true;
			}
		}

		if (this.invoiceForm.valid) {

			const data = {
				vendor: this.vendor_data,
				header: this.invoiceForm.value,
				grns: this.selected_grns,
				glcharges: this.glcharges,
				subtotal: this.invoiceTotal,
				taxes: this.taxTotal,
				total: this.totalTotal,
				user: this.user,
			}

			this.vendorService.createCredit(data).subscribe((result: any) => {
				if (result.success) {
					this.globalSearchService.showNotification('#' + result.transno + ' Created', 'success', 'bottom', 'right');

					const transId = result.id;
					if (transId && this.attachmentFiles.length > 0) {
						const uploads = this.attachmentFiles.map((file: File) =>
							from(this.readFileAsDataUrl(file)).pipe(
								switchMap((content: string) => this.vendorService.uploadVendorAttachment(transId, {
									content,
									name: file.name,
									mime: file.type || 'application/octet-stream'
								}))
							)
						);
						forkJoin(uploads).subscribe({
							next: () => {
								this.globalSearchService.showNotification('Attachments uploaded', 'success', 'bottom', 'right');
								this.attachmentFiles = [];
							},
							error: () => {
								this.globalSearchService.showNotification('Some attachments failed to upload', 'warning', 'bottom', 'right');
								this.attachmentFiles = [];
							}
						});
					} else {
						this.attachmentFiles = [];
					}

					const due = new Date(this.vendor_data.duedate)

					this.invoiceForm = this.fb.group({
						reference: ['', [Validators.required]],
						invoiceDate: [this.today, [Validators.required]],
						discountAmount: [0.00, [Validators.pattern('[0-9.]*')]],
						discountDate: [due, [Validators.required]],
						dueDate: [due, [Validators.required]],
						rate: [this.roundExchangeRate(this.vendor_data.exrate) ?? this.vendor_data.exrate, [Validators.pattern('[0-9.]*')]],
						grns: ['']
					});
					this.purchasingService.getRmaGrnDetails(this.vendor_data.supplierid).subscribe((r: any) => {
						this.open_grns = r;
						this.all_open_grns = r;
					})

					this.purchasingService.getRmaOpenGrnBatches(this.vendor_data.supplierid).subscribe((r: any) => {
						this.grn_batches = r;
						this.all_grn_batches = r;
					})

					this.invoiceForm.get('grns').valueChanges.subscribe(newValue => {

						if(newValue != '') {
							this.grn_batches = this.globalSearchService.filterItem(this.all_grn_batches, newValue, 'grnbatch,grnno,orderno,itemcode,sales_orderno')
							this.open_grns = this.globalSearchService.filterItem(this.all_open_grns, newValue, 'grnbatch,grnno,orderno,itemcode,sales_orderno')
						} else {
							this.grn_batches = this.all_grn_batches
							this.open_grns = this.all_open_grns
						}

					});

					this.invoiceForm.markAllAsTouched();
					this.newvendordata.emit(this.vendor_data.supplierid);
					this.glcharges = [];
					this.selected_grns = [];
					this.selected_grnbatches = [];

				} else {
					this.globalSearchService.showNotification(result.message || 'Credit could not be created.', 'danger', 'bottom', 'right');
				}

			});
		} else {
			this.globalSearchService.getFormValidationErrors(this.invoiceForm);
		}
	}
	openNoRGAItemsModal() {
		const dialogRef = this.dialog.open(NoRgaItemsModalComponent, {
			width: '90%',
			maxWidth: '1400px',
			data: { supplierid: this.vendor_data.supplierid }
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.success) {
				const createdRGAs = result.createdRGAs || [];
				const createdGRNs = result.createdGRNs || [];

				forkJoin({
					grnDetails: this.purchasingService.getRmaGrnDetails(this.vendor_data.supplierid),
					grnBatches: this.purchasingService.getRmaOpenGrnBatches(this.vendor_data.supplierid)
				}).subscribe((results: any) => {
					this.all_open_grns = results.grnDetails || [];
					this.all_grn_batches = results.grnBatches || [];
					this.open_grns = this.all_open_grns;
					this.grn_batches = this.all_grn_batches;

					if (createdRGAs.length > 0 || createdGRNs.length > 0) {
						const newGrnBatches = this.all_grn_batches.filter((batch: any) => {
							if (createdRGAs.length > 0) {
								return createdRGAs.includes(batch.orderno?.toString());
							}
							return false;
						});

						newGrnBatches.forEach((batch: any) => {
							const batchGrnbatch = parseFloat(batch.grnbatch) || 0;
							const batchOrderno = parseFloat(batch.orderno) || 0;

							if (!this.selected_grnbatches.some((selected: any) =>
								parseFloat(selected.grnbatch) == batchGrnbatch &&
								parseFloat(selected.orderno) == batchOrderno
							)) {
								this.selected_grnbatches.push(batch);
								const index = this.grn_batches.indexOf(batch);
								if (index >= 0) {
									this.grn_batches.splice(index, 1);
								}
							}

							this.all_open_grns.forEach((grn: any) => {
								if (parseFloat(grn.grnbatch) == batchGrnbatch &&
									parseFloat(grn.orderno) == batchOrderno) {
									const alreadySelected = this.selected_grns.some((selectedGrn: any) =>
										parseFloat(selectedGrn.grnno) == parseFloat(grn.grnno)
									);
									if (!alreadySelected) {
										if (grn.toinvoice === undefined || grn.toinvoice === null) {
											grn.toinvoice = (parseFloat(grn.qtyrecd) || 0) - (parseFloat(grn.quantityinv) || 0);
										}
										grn.toinvoice = parseFloat(grn.toinvoice) || 0;
										this.snapshotPoUnitPrice(grn);
										this.selected_grns.push(grn);
									}
								}
							});
						});

						this.getTotal();
					}

					this.globalSearchService.showNotification('Items added to invoice successfully', 'success', 'bottom', 'right');
				});
			}
		});
	}
	
	displayGrn(grn: any): string {
		if (!grn) {return '';}
		return `${grn.grnbatch} ${grn.grnno} ${grn.orderno} ${grn.itemcode || ''}`;
	}

	filteredGrnBatches(): any[] {
		if (!this.grn_batches) {
			return [];
		}

		let filtered = [...this.grn_batches];

		// Filter out batches that are already selected
		if (this.selected_grnbatches && this.selected_grnbatches.length > 0) {
			filtered = filtered.filter(batch => {
				return !this.selected_grnbatches.some(selectedBatch =>
					parseFloat(selectedBatch.grnbatch) == parseFloat(batch.grnbatch) &&
					parseFloat(selectedBatch.orderno) == parseFloat(batch.orderno)
				);
			});
		}

		return filtered;
	}

	ngOnDestroy() {
		if (this.referenceCheckSubscription) {
			this.referenceCheckSubscription.unsubscribe();
		}
	}

	ngAfterViewInit() {
		this.globalsService.getGLAccounts().subscribe((result: any) => {
			this.glaccounts = result;
			this.allglaccounts = result;
		});

		this.globalsService.getTaxes().subscribe((result: any) => {
			this.taxes = result;
		});

	}
}
